<div class="title">
    Your Shopping Cart
</div>

<div>Your cart is empty</div>